import { HttpFailedToFetchException } from "../model/httpException";
import { ProjectShort } from "../model/projectShort";
import { getAuthHeaders } from "../utils/authHeaders";
import { logException } from "../utils/logUtils";
import { fetchWithRetry } from "../utils/retry.util";

export class ProjectsApi {
  private static readonly BASE_URL = import.meta.env.VITE_API_URL;

  static async getProjectsForUser(): Promise<ProjectShort[]> {
    try {
      const headers = await getAuthHeaders({});

      const response = await fetchWithRetry(
        `${this.BASE_URL}/projects?include_without_names=false&sort_by=last_access&sort_order=desc`,
        {
          method: "GET",
          headers,
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        logException("Projects API error (/projects):", {
          status: response.status,
          statusText: response.statusText,
          body: errorText,
        });
        throw new HttpFailedToFetchException();
      }

      const data = await response.json();
      return data.projects;
    } catch (error) {
      throw new HttpFailedToFetchException();
    }
  }
}
